import SavingsPlanService, { SavingsPlanTypes } from "../services/SavingsPlanService";

// Estado ACTIVE de un plan de ahorro
const ActiveSavingsPlanStatus = 4;

/**
 * Plan con el que se puede participar en una competición: activo y que no sea gestionado.
 * Es el mismo filtro que aplican las pantallas de inscripción al listar los planes.
 */
export const isCompetitionCompatiblePlan = (plan: { status?: number, type?: number } | undefined | null): boolean =>
    plan?.status === ActiveSavingsPlanStatus && plan?.type !== SavingsPlanTypes.Saver;

/**
 * Indica si el usuario puede ir a la inscripción de una competición.
 * Solo se bloquea cuando el plan activo es gestionado y el usuario no tiene ningún otro plan compatible
 * (por ejemplo, el de Educación Financiera, que nunca se elige como plan activo por defecto).
 */
export const canJoinCompetitionWithPlans = async (activePlan: { type?: number } | undefined | null, userId: number | undefined): Promise<boolean> =>
{
    if(activePlan?.type !== SavingsPlanTypes.Saver || userId === undefined)
    {
        return true;
    }

    try
    {
        const savingsPlans = await SavingsPlanService.getSavingsPlansAndStatusLite(userId);
        return (savingsPlans ?? []).some(isCompetitionCompatiblePlan);
    }
    catch(error)
    {
        // La pantalla de inscripción vuelve a cargar los planes y muestra su propio error de carga
        console.error("Error al comprobar los planes para la competición", error);
        return true;
    }
};

export const ManagedPlanOnlyMessage = "Los planes de tipo gestionado no pueden participar en la competición y no tienes ningún otro plan activo con el que hacerlo.";
